// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1v7h6","item":"PaymentsMobile_item__1vEI7","label":"PaymentsMobile_label__3Z3cd","amount":"PaymentsMobile_amount__3OC6-"};